import { render, staticRenderFns } from "./QuestionsColumn.vue?vue&type=template&id=02b69763&scoped=true&"
import script from "./QuestionsColumn.vue?vue&type=script&lang=js&"
export * from "./QuestionsColumn.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsColumn.vue?vue&type=style&index=0&id=02b69763&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b69763",
  null
  
)

export default component.exports